import React from 'react';
import '../App.css';

export default class ForgotPasswordForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {username: undefined, email: undefined};
  }

  refresh(e) {
    if (e) e.preventDefault();
    window.location = '/';
  }

  submitForgotPassword(event) {
    event.preventDefault();
    console.log('  Creating user!');
    // Post to the users API endpoint to create a new user validation
    //    req and associate the user with this area.
    // All the data we need should be in the state.
    console.log('this.state.username: ' + this.state.username);
    console.log('this.state.email: ' + this.state.email);
    try {
      let that = this;
      let url = window.location.protocol + '//' + window.location.host;
      let formData = new FormData();
      formData.append('username', this.state.username);
      formData.append('email', this.state.emailAddress);
      fetch(`${url}/api/v1/forgot_password`, {method: 'POST', body: formData}, function(err, data) {
        if (err) {
          that.setState({error: err});
          console.log('Error creating account req!: ' + err);
        } else if (data) {
          // We got data. Tell them to check their email which should
          // contain a link with a code.
          let jsonData = JSON.parse(data.body);
          if (jsonData['ValidationError'] || (data.statusCode !== 200 && data.statusCode !== 204)) {
            if (jsonData['validationError']) {
              that.setState({error: jsonData['validationError']});
            } else if (jsonData['error']) {
              that.setState({error: jsonData['error']});
            } else {
              that.setState({error: data.body});
              // alert(data.body);
            }
          } else {
            that.setState({successMsg: 'Se uma conta já existir com o seu nome de usuário ou e-mail especificado, uma mensagem de redefinição de senha será enviada para o seu endereço de e-mail registrado em breve. '});
          }
        } else {
          console.log('Empty payload from account creation req!');
        }
      });
    } catch(e) {
      console.log('Error creating the user account req!; ' + e);
    }
  }

  render() {
    // const modalStyle = {'marginTop': '14px'};
    if (this.state.successMsg) {
      return (
        <div className='signupForm'>
          <div className='rightAlignDiv'>
            {this.state.successMsg}
          </div>
        </div>
      );
    } else {
      return (
        <div className='greyOverlay'>
          {this.state.error ? <div className='bannerMessageRed'>{this.state.error}</div> : ''}
          <div className='basicModal'>
            <b>Esqueceu sua senha?</b>
            <br /><p />
            Enter seu username: <input className='shortInput' placeholder='Username' type='text' onChange={(e) => this.setState({username: e.target.value})}
                   value={this.state.username || ''} /> &nbsp;&nbsp; <br />ou <br />
            Enter seu email: <input className='mediumInput' placeholder='Email' type='text' onChange={(e) => this.setState({email: e.target.value})}
                   value={this.state.email || ''} />
            <p />
            &nbsp;&nbsp;&nbsp;<button onClick={(e) => this.submitForgotPassword(e)} className='verifyButton'>Entrar</button>
          </div>
        </div>
      );
    }
  }
}
